import { render, staticRenderFns } from "./steelbox.vue?vue&type=template&id=5c5af906&scoped=true"
import script from "./steelbox.vue?vue&type=script&lang=js"
export * from "./steelbox.vue?vue&type=script&lang=js"
import style0 from "./steelbox.vue?vue&type=style&index=0&id=5c5af906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5af906",
  null
  
)

export default component.exports